import type { FC } from 'react';
import { Helmet } from 'react-helmet';

import type { PricingPage_content_pricing_pages_translations as MetaData } from './__generated__/PricingPage';

const PricingMeta: FC<{
  metaData: MetaData | undefined | null;
}> = ({ metaData }) => {
  const { page_title, meta_title, meta_description } = metaData ?? {};

  return (
    <Helmet titleTemplate={'%s'}>
      <title>{page_title || ''}</title>
      <meta name="title" content={meta_title || ''} />
      <meta name="description" content={meta_description || ''} />
    </Helmet>
  );
};

export default PricingMeta;
